import React from 'react';
import { Gift, HelpCircle } from 'react-feather';

function TipIncomeGrid({ formData, onDataChange }) {
  const tooltipText = "Cash or credit tips you received that you did NOT report to your employer.";

  return (
    <div className="form-section">
      <div className="content-box-header">
        <div className="header-title-with-help">
          <h2><Gift size={20} className="icon-orange" /> Unreported Tip Income</h2>
          <div className="has-tooltip header-help-icon" data-tooltip={tooltipText}>
            <HelpCircle size={18} />
          </div>
        </div>
      </div>

      <div className="dependent-card">
        <div className="form-group">
          <label style={{ fontWeight: 600, color: '#554633ff' }}>Total Unreported Tips</label>
          <p style={{ fontSize: '0.9rem', color: '#8b7a64ff', marginBottom: '0.75rem' }}>
            Enter the total amount of tips not reported to your employer.
          </p>
          <div className="input-with-prefix">
            <span className="prefix">$</span>
            <input 
              type="number" 
              name="manualTipIncome" 
              value={formData?.manualTipIncome ?? ''} 
              onChange={onDataChange} 
              placeholder="0" 
            />
          </div>
        </div>

        <div className="form-group" style={{ marginTop: '1.5rem', paddingTop: '1.5rem', borderTop: '1px dashed #f0e9e2ff' }}>
          <div className="header-title-with-help" style={{ marginBottom: '0.5rem' }}>
            <label style={{ fontWeight: 600, color: '#554333ff' }}>Tax on Unreported Tips (Form 4137)</label>
            <div className="has-tooltip header-help-icon" data-tooltip="Social Security and Medicare tax on tips you did not report to your employer.">
              <HelpCircle size={16} />
            </div>
          </div>
          <div className="input-with-prefix">
            <span className="prefix">$</span>
            <input 
              type="number" 
              name="unreportedTipsTax" 
              value={formData?.unreportedTipsTax ?? ''} 
              onChange={onDataChange} 
              placeholder="0" 
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default TipIncomeGrid;